module.exports = __webpack_public_path__ + "img/2.015a85b6.webp";